import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import App from './App';
import AppErrorBoundary from './components/AppErrorBoundary';
import { applyConsentResources, loadConsent } from './consent';

applyConsentResources(loadConsent());
const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary sectionName="AWN AdPulse" resetLabel="Retry application" showReload>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
